import React, {useEffect, useState} from 'react';
import TypeAuto from '../components/AutoComplete';

export default function BasicModal({domain, id, nameL, fetchAgain}) {
  const [open, setOpen] = useState(false);
  const setStatus = (param) => {
    setOpen(param);
    document.body.style.overflow = param ? "hidden" : "auto";
  }
  const closeModal = () => {
    setStatus(false);
  }

  const [name, setName] = useState(nameL);

  const handleChangeName = (e) => {
    setName(e.target.value);
  }

  const [delCheck, setDelCheck] = useState(false);

  const saveChanges = async () => {
    const requestBody = {
      region_id: id,
      region_name: name,
    }
    const requestParams ={
      method: "POST",
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(requestBody)
    }
    try {
      const response = await fetch(`https://${domain}/api/regions`, requestParams);
      if(!response.ok) throw new Error();
      if(delCheck) del();
      closeModal();
      fetchAgain();
    }catch(e){console.error(e);}
  }

  const del = async () => {
    try {
      const response = await fetch(`https://${domain}/api/regions/${id}`, {
        method: 'DELETE'
      });
      if(!response.ok) throw new Error();
    }catch(e){console.error(e);}
  }

  useEffect(() => {
    setName(nameL);
  }, [open])

  return (
    <div>
      <button className='requestBtn' onClick={() => {setStatus(true)}}>Edit</button>
      {open && 
        <div className="modal-window">
          <div className='edit-modal-box modal-box'>
              <div className='input-areas'>
                <label>Name of Region</label>
                <input className='inputs' type='text' value={name} onChange={handleChangeName}/>
              </div>
              {/* <TypeAuto types={types.map(t => t.typ_name)} type={type} setType={handleTypeChange} domain={domain} fetchAgain={fetchTypesAgain}/> */}
              <div><input type="checkbox" onChange={() => {setDelCheck(!delCheck)}}/>Delete region</div>
              <div style={{display:'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px'}}>
                <button className='requestBtn' onClick={saveChanges}>Save</button>
                <button className='closeBtn' onClick={closeModal}>Cancel</button>
              </div>
          </div>
        </div>
      }
    </div>
  );
}
